<template>
  <div class="error-block">
    <div class="error-block__left animate__animated animate__fadeIn d2">
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.9,-64.4C41.9,-56.4,41.9,-40.3,46.9,-28.2C51.9,-16.1,61.9,-8.1,67.4,3.2C73,14.4,74,28.9,66.8,37.1C59.5,45.3,44,47.4,31.5,53.9C19,60.4,9.5,71.4,-2.7,76.1C-14.9,80.7,-29.7,79,-37.9,70C-46.1,60.9,-47.7,44.7,-48.7,31.8C-49.6,18.9,-50,9.5,-54.2,-2.4C-58.4,-14.3,-66.4,-28.6,-62.4,-36.3C-58.5,-44,-42.6,-45.2,-30.2,-50C-17.8,-54.8,-8.9,-63.4,2.5,-67.8C14,-72.1,27.9,-72.3,34.9,-64.4Z" transform="translate(100 100)" />
      </svg>
      <ui-icon
        class="error-block__left__icon"
        name="storage"
      />
    </div>
    <div class="error-block__right">
      <p class="error-block__title mb-2">
        Problème d'accès au stockage local du navigateur
      </p>
      <div class="error-block__message mb-2 font-size-120 animate__animated animate__fadeIn d6">
        <p class="mb-2">
          Cela peut arriver si :
        </p>
        <ul class="list-style-circle px-4 mb-2">
          <li class="mb-1">Les cookies et le stockage local sont bloqués dans les paramètres de votre navigateur</li>
          <li class="mb-1">Vous utilisez le mode navigation privée avec des restrictions</li>
          <li class="mb-1">Une extension de navigateur bloque l'accès au stockage</li>
          <li>Le stockage du navigateur est plein ou corrompu</li>
        </ul>
      </div>
      <div class="error-block__actions my-4 animate__animated animate__fadeIn d-2">
        <button
          class="error-block__clear-btn"
          @click="clearStorageAndReload"
        >
          <ui-icon name="delete_sweep" />
          Vider le stockage local et recharger
        </button>
      </div>
      <p class="error-block__message mb-2 animate__animated animate__fadeIn d-2">
        Cause technique
      </p>
      <div class="error-block__payload animate__animated animate__fadeIn d-2">
        <ui-icon name="terminal" />
        <p>{{ errorMessage || 'Erreur inconnue' }}</p>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  errorMessage?: string
}>()

function clearStorageAndReload() {
  try {
    localStorage.clear()
    sessionStorage.clear()
  }
  catch {
    // Ignorer si le stockage n'est pas accessible
  }
  window.location.reload()
}
</script>

<style lang="sass" scoped>
$svg-size: 480px

.error-block
  display: flex
  align-items: baseline

  &__title
    font-size: 150%
    font-weight: $font-weight-bold
    line-height: 1.2
    color: $white

  &__left
    $icon-size: 60px
    position: relative
    margin-right: space-x(8)

    &__icon
      font-size: $icon-size

    svg
      opacity: 0.2
      left: space-x(-18)
      top: space-x(-18)
      position: absolute
      width: $svg-size
      height: $svg-size

      path
        fill: mix-alpha($danger, 80%)

  &__right
    flex-grow: 1

  &__message
    font-size: 140%
    margin-bottom: space-x(4)
    font-weight: $font-weight-light
    line-height: 1.2
    color: $white

  &__payload
    display: flex
    gap: space-x(2)
    font-size: 20px
    font-family: $font-family-monospace
    font-weight: $font-weight-bold
    padding: $card-spacer-y $card-spacer-x
    border-radius: $border-radius
    background: mix-alpha($white, 5%)

    .ui-icon
      position: relative
      font-size: 32px

    p
      align-self: flex-end

  &__clear-btn
    display: inline-flex
    align-items: center
    gap: space-x(2)
    padding: space-x(3) space-x(4)
    font-size: 1.2rem
    font-weight: $font-weight-bold
    color: $wine-berry
    background: $white
    border: none
    border-radius: $border-radius * 4
    cursor: pointer
    transition: all 0.2s ease

    &:hover
      background: darken($white, 10%)

    .ui-icon
      font-size: $icon-default-size * 1.2
</style>

